<template>
    <svg :class="svgClass">
        <use :xlink:href="iconName"></use>
    </svg>
</template>
  
<script>
export default {
    name: 'svg-component',
    props: {
        iconClass: { type: String, required: true },
        className: { type: String, default: '' }
    },
    data() {
        return {
            iconName: '',
            svgClass: 'svg-icon'
        }
    },
    watch: {
        iconClass: {
            handler(value) {
                if (value) {
                    this.iconName = `#icon-${value}`
                }
            },
            immediate: true
        },
        className: {
            handler(value) {
                if (value) {
                    this.svgClass = 'svg-icon' + this.props.className
                }
            },
            immediate: true
        },

    }
    // computed: {
    // iconName() {
    //     return `#icon-${this.props.iconClass}`
    // },
    // svgClass() {
    //     console.log(this.props)
    //     if (this.props.className) {
    //         return 'svg-icon' + this.props.className
    //     } else {
    //         return 'svg-icon'
    //     }
    // }
    // }
}
</script>
  
<style scoped>
.svg-icon {
    width: 1em;
    height: 1em;
    display: inline-block;
    vertical-align: -0.15em;
    overflow: hidden;
}
</style>